import { DataBean } from "../DataBean";

export class FunctionalCompetence extends DataBean {


    public async getFunctionalCompetenceCatalog(IDmain: number | null, IDentailment: number | null, IDfamily: number | null): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getFunctionalCompetenceCatalog_Number_Number_Number", [IDmain, IDentailment, IDfamily]);
    }
}